import { CollaboratorList } from "../share/CollaboratorList";

import "./ShareInternalDialog.scss";

interface AccessListDialogProps {
  drawingId: string;
  drawingName: string;
  onClose: () => void;
}

// Diálogo focado em "quem tem acesso" a um desenho — aberto pelo menu do card.
// Reaproveita o CollaboratorList (ver/alterar permissão/remover) e o visual do
// ShareInternalDialog, sem o formulário de convite.
export const AccessListDialog = ({
  drawingId,
  drawingName,
  onClose,
}: AccessListDialogProps) => {
  return (
    <div className="share-internal-overlay" onClick={onClose}>
      <div
        className="share-internal-dialog"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="share-internal-dialog__close"
          onClick={onClose}
          aria-label="Fechar"
        >
          &times;
        </button>

        <header className="share-internal-dialog__header">
          <h2>Pessoas com acesso</h2>
          <p className="share-internal-dialog__subtitle">
            Quem pode acessar <strong>{drawingName}</strong>
          </p>
        </header>

        <div className="share-internal-dialog__body">
          <CollaboratorList drawingId={drawingId} hideHeader />
        </div>

        <footer className="share-internal-dialog__actions">
          <button className="share-internal-dialog__btn" onClick={onClose}>
            Fechar
          </button>
        </footer>
      </div>
    </div>
  );
};
